"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsCategory = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./index.scss");
var React = require("react");
var FieldsCategory = function (props) { return (React.createElement("div", { className: 'report-fields-category' },
    React.createElement("h3", { className: 'report-fields-category-title' }, (0, translation_1.getLocalization)("management/reports/modal/category/".concat(props.categoryName))),
    props.children)); };
exports.FieldsCategory = FieldsCategory;
